import { CirclePlus } from "lucide-react";
import { observer } from "mobx-react-lite";
import type { FC } from "react";

import { CustomButton } from "@/components/atoms";
import { commonIconProps20 } from "@/utils/constants";

interface BrandFieldProps {
  name: string;
  addClick: () => void;
}

const BrandField: FC<BrandFieldProps> = observer(({ name, addClick }) => {
  return (
    <li className="flex justify-between px-3.5 py-4 items-center border-b border-gray-200">
      <p className="font-bold text-sm">{name}</p>
      <CustomButton
        type="button"
        size="sm"
        iconSize="md"
        onClick={addClick}
        data-testid={`brand-field-add-button-${name}`}
      >
        <CirclePlus {...commonIconProps20} />
        Add details
      </CustomButton>
    </li>
  );
});

export default BrandField;
